import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GlobeView from './pages/GlobeView';
import ShowcaseView from './pages/ShowcaseView';
import CentroViewer from './pages/CentroViewer';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import ConstructorAdmin from './pages/ConstructorAdmin';
import Generador360 from './pages/Generador360';
import './App.css';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<GlobeView />} />
        <Route path="/showcase" element={<ShowcaseView />} />
        <Route path="/centro/:id" element={<CentroViewer />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/panel" element={<AdminPanel />} />
        <Route path="/admin/constructor" element={<ConstructorAdmin />} />
        <Route path="/admin/generar-360" element={<Generador360 />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
